/**
 *
 * File: UserPrefsRequest.js
 *
 */
(function () {
    angular
        .module('maApp.remoteRequests')
        .factory('UserPrefsRequest', UserPrefsRequest);

    UserPrefsRequest.$inject = ['$http', 'endpoint', 'Auth', '$interpolate', '$httpParamSerializer', 'RequestError'];

    function UserPrefsRequest($http, endpoint, Auth, $interpolate, $httpParamSerializer, RequestError) {

        return {
            'get':fetchUserPreferences,
            'put':updateUserPreferences
        };

        function fetchUserPreferences(userid) {
            return $http({
                method:'GET',
                url:createPreferencesUrl(userid),
                params:angular.extend({
                    dataonly:1
                }, Auth.getUserAuth())

            })
                .then(fetchSuccess, fetchFail);

            function fetchSuccess(response){
                return response.data;
            }
            function fetchFail(response){
                throw new RequestError(response, 'Failed to fetch user preferences');
            }
        }

        function updateUserPreferences(userid, data) {
            return $http({
                method: 'POST',
                url: createPreferencesUrl(userid),
                data: $httpParamSerializer(angular.extend({}, data, Auth.getUserAuth())),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(postSuccess, postFail);

            function postSuccess(response) {
                return response.data.message;
            }

            function postFail(response){
                throw new RequestError(response, 'Failed to update preferences');
            }
        }

        function createPreferencesUrl(userid){
            return $interpolate('{{endpoint}}preferences/{{userid}}/')({'endpoint':endpoint, 'userid':encodeURIComponent(userid)});
        }
    }
})();